import React from "react";
import styles from './WorkLeave.module.scss'
import Input from "../../Components/Input";
import ButtonsBarLookup from '../../Components/ButtonsBarLookup'
import Messages from '../../Components/Messages'
import http from "../../Api/http";
import ProgressSpinner from '../../Components/ProgressSpinner'
import MessageBox from '../../Components/MessageBox'
import DeleteNoteDialog from '../../Components/DeleteNoteDialog'
import Util from '../../Util'
import Dropdown from '../../Components/Dropdown';
import Card from '../../Components/Card'
import InputTextArea from '../../Components/InputTextArea';
import Calendar from '../../Components/Calendar'
import SiteMap from '../../Components/SiteMap';
import ScrollTop from '../ScrollButton';
import WFTrans from '../WFTrans';
import InputTime from "../../Components/InputTime/InputTime";
import { FileUpload } from "primereact/fileupload";
import Attachments from "../Attachments";

const $ = window.$;
const stringHash = require('@sindresorhus/string-hash');

export default class WorkLeave extends React.Component {

    constructor(props) {
        super(props);
        this.hash = null
        this.nowDate = new Date()
        this.toDate = new Date();
        this.toDate.setHours(this.nowDate.getHours()+1,this.nowDate.getMinutes(),0);
        this.state = {
            loading: true,
            mode: 'new',
            formErrors: { empCode: '', empName: '', period: '', fromDate: '', toDate: '', fromTime: '', toTime: '', notes: '' },
            deleteErrors: { deleteNote: '' },
            periodList: Util.getPeriodList(),
            isDesktop: window.innerWidth > 1250,

            dataObject: {
                id: 0,
                empCode: this.props.match.params.empCode || localStorage.getItem("useridHR") || '',
                empName: Util.getEmployeeInfo() || '',
                requestDate: this.nowDate,
                period: { id: 0, name: $.strings.workLeave.lessThanDay },

                fromDate: this.nowDate,
                toDate: this.nowDate,
                daysCount: 0,
                fromTime: this.nowDate,
                toTime: this.toDate,//Util.getCurrentTimePlusHour(this.nowDate),
                duration: '01:00',
                notes: ''
            }
        }
    }

    updatePredicate = () => {
        return window.innerWidth > 1250
    }

    componentDidMount = async () => {
        if (!$.license.SelfService_Module) {
            Util.goTo('/License');
            return;
        }
        if (!Util.checkRights(611)) {
            Util.goTo('/Access');
            return;
        }
        let _isDesktop = this.updatePredicate();

        if (!this.props.match.params.id) {
            let empCode = this.props.match.params.empCode || localStorage.getItem("useridHR") + "";
            let empName = Util.getEmployeeInfo() || ''
            if (empCode !== localStorage.getItem("useridHR") + "") {
                let obj = await this.getEmployeeInfo(empCode);
                empCode = obj.Code;
                empName = obj.Name;
            }
            this.setState({ dataObject: { ...this.state.dataObject, empCode: empCode, empName: empName }, isDesktop: _isDesktop, loading: false })
        }
        else {
            if (this.props.match.params.id) {
                let data = await this.showWorkLeave(this.props.match.params.id)
                this.loadData(data)
            }
        }

        setTimeout(() => { this.drpPeriod.focusInput.focus() }, 10);
    }

    hashState = () => {
        let newHash = stringHash(JSON.stringify(this.state.dataObject))
        return newHash
    }

    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;

        this.setState({ dataObject: { ...this.state.dataObject, [name]: value } })
    }

    handlePeriod = (e) => {
        let period = e.target.value;
        let daysNo = 0;
        if (period.id > 0)
            daysNo = 1;
        this.setState({ dataObject: { ...this.state.dataObject, period: e.target.value, daysCount: daysNo } });
    }

    handleFromDate = (e) => {
        this.setState({ dataObject: { ...this.state.dataObject, fromDate: e.target.value } }, () => this.setToDate())
    }
    setToDate = () => {
        if (this.state.dataObject.period.id !== 2) {
            this.setState({ dataObject: { ...this.state.dataObject, toDate: this.state.dataObject.fromDate } }, () => this.calculateDaysNo())
        }
        else {
            this.calculateDaysNo()
        }
    }
    handleToDate = (e) => {
        this.setState({ dataObject: { ...this.state.dataObject, toDate: e.target.value } }, () => this.setFromDate())
    }
    setFromDate = () => {
        if (this.state.dataObject.period.id !== 2) {
            this.setState({ dataObject: { ...this.state.dataObject, fromDate: this.state.dataObject.toDate } }, () => this.calculateDaysNo())
        }
        else {
            this.calculateDaysNo()
        }
    }
    calculateDaysNo = () => {
        try {
            let fromDate = this.state.dataObject.fromDate
            let toDate = this.state.dataObject.toDate

            const _fromDate = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0);
            const _toDate = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 0, 0, 0);
            let temp = 1000 * 3600 * 24;

            let daysNo = Math.floor((_toDate - _fromDate) / temp);

            daysNo += 1;
            if (this.state.dataObject.period.id === 0)
                daysNo = 0;
            else if (this.state.dataObject.period.id === 1)
                daysNo = 1;

            this.setState({ dataObject: { ...this.state.dataObject, daysCount: daysNo } })
        }
        catch (e) {

        }
    }

    handleFromTime = (e) => {
        this.setState({ dataObject: { ...this.state.dataObject, fromTime: e.value } }, () => this.calculateHoursNo())
    }
    setToTime = () => {
        if (this.state.dataObject.toTime <= this.state.dataObject.fromTime) {
            let toTimeTemp = Util.getCurrentTimePlusHour(this.state.dataObject.fromTime)
            this.setState({ dataObject: { ...this.state.dataObject, toTime: toTimeTemp } }, () => this.calculateHoursNo())
        }
        else {
            this.calculateHoursNo()
        }
    }
    handleToTime = (e) => {
        this.setState({ dataObject: { ...this.state.dataObject, toTime: e.value } }, () => this.calculateHoursNo())
    }
    setFromTime = () => {
        if (this.state.dataObject.toTime <= this.state.dataObject.fromTime) {
            let fromTimeTemp = Util.getCurrentTimeMinusHour(this.state.dataObject.toTime)
            this.setState({ dataObject: { ...this.state.dataObject, fromTime: fromTimeTemp } }, () => this.calculateHoursNo())
        }
        else {
            this.calculateHoursNo()
        }
    }

    calculateHoursNo = () => {
        try {
            let fromDate = this.state.dataObject.fromTime;
            let toDate = this.state.dataObject.toTime;

            var hoursNo = ((new Date(1, 1, 1, toDate.getHours(), toDate.getMinutes(), 0) -
                new Date(1, 1, 1, fromDate.getHours(), fromDate.getMinutes(), 0)) / 60000);
            let obj = Util.getNumberByTimeFormat(hoursNo);
            let hours = obj.hours + "";
            if (hours.length === 1)
                hours = "0" + hours;

            let minutes = obj.minutes + "";
            if (minutes.length === 1)
                minutes = "0" + minutes;

            let result = hours + ":" + minutes;


            this.setState({ dataObject: { ...this.state.dataObject, duration: result } })
        }
        catch (e) {

        }
    }


    validateField() {

        let fieldValidationErrors = this.state.formErrors;

        let _empCode = this.state.dataObject.empCode
        fieldValidationErrors._empCode = _empCode ? '' : $.strings.requiredFiled;

        let _empName = this.state.dataObject.empName;
        fieldValidationErrors.empName = _empName ? '' : $.strings.requiredFiled;

        let _period = this.state.dataObject.period;
        fieldValidationErrors.period = _period ? '' : $.strings.requiredFiled;

        let _fromDate = this.state.dataObject.fromDate;
        fieldValidationErrors.fromDate = _fromDate ? '' : $.strings.requiredFiled;

        let _toDate = this.state.dataObject.toDate;
        fieldValidationErrors.toDate = _toDate ? '' : $.strings.requiredFiled;

        let _fromTime = this.state.dataObject.fromTime
        fieldValidationErrors.fromTime = _fromTime ? '' : $.strings.requiredFiled;

        let _toTime = this.state.dataObject.toTime
        fieldValidationErrors.toTime = _toTime ? '' : $.strings.requiredFiled;

        let _notes = this.state.dataObject.notes;
        fieldValidationErrors.notes = _notes ? '' : $.strings.requiredFiled;

        if (this.state.dataObject.duration.includes('-')) {
            Util.showErrorMsg(this.messages, $.strings.workLeave.timeError)
            return false;
        }

        this.setState({
            formErrors: fieldValidationErrors,
            empCodeValid: _empCode,
            empNameValid: _empName,
            periodValid: _period,
            fromDateValid: _fromDate,
            toDateValid: _toDate,
            fromTimeValid: _fromTime,
            toTimeValid: _toTime,
            notesValid: _notes

        }, this.validateForm);

        return _empCode && _empName && _period && _fromDate && _toDate && _fromTime && _toTime && _notes;

    }
    validateForm() {
        let isFormValid = this.state.empCodeValid && this.state.empNameValid && this.state.periodValid
            && this.state.fromDateValid && this.state.toDateValid && this.state.fromTimeValid && this.state.toTimeValid && this.state.notesValid
        this.setState({ formValid: isFormValid });
        return isFormValid
    }

    render() {

        let siteMapItems = [
            { label: $.strings.links.requests.menu },
            {
                label: <div>
                    {$.strings.links.requests.workLeave + " "}
                    {(this.state.mode === "new" ? <span style={{ color: 'red' }}>{" (" + $.strings.newMode + ")"}</span> : '')}
                </div>
            }
        ];

        const siteMapHome = { icon: 'pi pi-home', url: "/" }

        return (
            <div ref="divMain" className={styles.addWorkLeave}>

                <Card>
                    <SiteMap model={siteMapItems} home={siteMapHome} />
                </Card>
                <div className="p-grid">
                    <div className="p-col-12 p-lg-12 p-md-12" >
                        <ButtonsBarLookup
                            onNew={this.state.dataObject.id <= 0 ? this.resetFields : undefined}
                            onSave={this.state.dataObject.id <= 0 ? this.onSave : undefined}
                            onTransDetails={this.state.dataObject.id > 0 ? this.wfTransDetails : undefined}
                            onShowAttachment={this.state.dataObject.id > 0 && this.state.dataObject.file_id > 0 ? this.onShowAttachment : undefined}
                        />
                    </div>
                </div>
                <ProgressSpinner loading={this.state.loading} />
                <div className="p-grid" style={{ width: '100%' }}>
                    <div className="p-lg-12 p-sm-12" style={{ width: '100%' }}>
                        <Messages innerRef={(el) => this.messages = el} />
                    </div>
                </div>

                <MessageBox header={$.strings.appName} visible={this.state.dlgOnNewVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onNew(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnPrevVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onPrevious(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnNextVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onNext(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnFirstVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onFirst(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnLastVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onLast(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnDeleteVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onDelete(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnCloneVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.onClone(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />
                <MessageBox header={$.strings.appName} visible={this.state.dlgOnCloseVisible} onYes={e => this.onSaveWithoutClose(e, false)} toDo={e => this.btnClose(e, false)} onCancel={this.onCancel}
                    appendTo={this.props.parent} />

                <DeleteNoteDialog ref={ref => this.deleteNoteDlg = ref} visible={this.state.dlgDeleteNoteVisible} deleteErrors={this.state.deleteErrors} appendTo={this.props.parent}
                    onYes={this.btnDeleteYes} onNo={this.DeleteCancel} deleteNote='' />

                <Card>
                    <div className="p-grid">
                        <div className="-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtCode = el}
                                type="text"
                                id="id"
                                keyfilter="pnum"
                                value={this.state.dataObject.id || ''}
                                autofocus={true}
                                autocomplete="off"
                                onChange={this.handleUserInput}
                                caption={$.strings.workLeave.code}
                                readOnly={true}
                                disabled
                                style={{ color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                            />
                        </div>
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                            <Calendar
                                id="requestDate"
                                innerRef={(el) => this.dtpRequestDate = el}
                                value={this.state.dataObject.requestDate}
                                caption={$.strings.workLeave.requestDate}
                                onChange={this.handleUserInput}
                                tooltip={$.strings.workLeave.requestDate}
                                readOnlyInput={true}
                                readOnly={true}
                                disabled
                                style={{ color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                            />
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-6 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtEmpCode = el}
                                type="text"
                                id="empCode"
                                keyfilter="pnum"
                                maxLength="4"
                                value={this.state.dataObject.empCode || ''}
                                autofocus={true}
                                autocomplete="off"
                                caption={$.strings.workLeave.empCode}
                                isRequired={true}
                                onChange={this.handleUserInput}
                                readOnly={true}
                                disabled
                                style={{ color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                            />
                        </div>
                        <div className="p-col-12 p-xl-4 p-lg-8 p-md-6 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtEmpName = el}
                                type="text"
                                id="empName"
                                maxLength="70"
                                value={this.state.dataObject.empName || ''}
                                autofocus={true}
                                caption={$.strings.workLeave.empName}
                                onChange={this.handleUserInput}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                readOnly={true}
                                disabled
                                style={{ width: '100%', color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                            />
                        </div>
                    </div>
                </Card>
                <Card>
                    <div className="p-grid">
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <Dropdown
                                id="period"
                                innerRef={e => this.drpPeriod = e}
                                value={this.state.dataObject.period || ''}
                                options={this.state.periodList}
                                showClear={true}
                                caption={$.strings.workLeave.period}
                                onChange={this.handlePeriod}
                                formErrors={this.state.formErrors}
                                optionLabel="name"
                                filter={true}
                                filterBy="code,name"
                                filterMatchMode="contains"
                                isRequired={true}
                                tooltip={$.strings.workLeave.period}
                                tooltipOptions={{ position: 'top' }}
                                disabled={this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <Calendar
                                id="fromDate"
                                ref={e => this.dtpFromDate = e}
                                value={this.state.dataObject.fromDate}
                                caption={$.strings.workLeave.fromDate}
                                onChange={this.handleFromDate}
                                tooltip={$.strings.workLeave.fromDate}
                                readOnlyInput={true}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                disabled={this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <Calendar
                                id="toDate"
                                ref={e => this.dtpToDate = e}
                                value={this.state.dataObject.toDate}
                                caption={$.strings.workLeave.toDate}
                                onChange={this.handleToDate}
                                tooltip={$.strings.workLeave.toDate}
                                readOnlyInput={true}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                //disabled={this.state.dataObject.id > 0 ? true : false}
                                disabled={this.state.dataObject.period.id !== 2 || this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtDaysCount = el}
                                id="daysCount"
                                value={this.state.dataObject.daysCount}
                                autofocus={true}
                                caption={$.strings.workLeave.daysCount}
                                onChange={this.handleUserInput}
                                readOnly={true}
                                disabled
                                style={{ width: '100%', color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                            />
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <InputTime
                                id="fromTime"
                                ref={e => this.dtpFromTime = e}
                                value={this.state.dataObject.fromTime}
                                caption={$.strings.workLeave.fromTime}
                                valueChanged={this.handleFromTime}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                disabled={this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <InputTime
                                id="toTime"
                                ref={e => this.dtpFromTime = e}
                                value={this.state.dataObject.toTime}
                                caption={$.strings.workLeave.toTime}
                                valueChanged={this.handleToTime}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                disabled={this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                        <div className="p-col-12 p-xl-2 p-lg-4 p-md-4 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtDuration = el}
                                id="duration"
                                value={this.state.dataObject.duration}
                                autofocus={true}
                                caption={$.strings.workLeave.duration}
                                onChange={this.handleUserInput}
                                readOnly={true}
                                disabled
                                style={{ width: '100%', color: 'black', backgroundColor: '#dbdbdb', fontWeight: 'bold', fontSize: '13px' }}
                            />
                        </div>
                    </div>

                    <div className="p-grid">
                        <div className="p-col-12 p-xl-6 p-lg-12 p-md-12 p-sm-12">
                            <InputTextArea
                                innerRef={ref => this.txtNotes = ref}
                                type="text"
                                id="notes"
                                maxLength="100"
                                value={this.state.dataObject.notes}
                                caption={$.strings.workLeave.notes}
                                onChange={this.handleUserInput}
                                isRequired={true}
                                formErrors={this.state.formErrors}
                                disabled={this.state.dataObject.id > 0 ? true : false}
                            />
                        </div>
                    </div>
                    <div className="p-grid">
                        <div className="p-col-12 p-xl-6 p-lg-12 p-md-12 p-sm-12">
                            <div >
                                <label for="file-upload" className={styles.customFileUpload}>
                                    {$.strings.vacations.uploadFile}
                                </label>
                                <FileUpload chooseLabel={$.strings.vacations.uploadFile} name="file-upload-prime" url=""
                                    onSelect={this.handleChangePrime} auto maxFileSize={5000000} disabled={this.state.dataObject.id > 0}
                                    invalidFileSizeMessageSummary={$.strings.fileSizeError}
                                    invalidFileSizeMessageDetail={""} />
                            </div>
                        </div>
                    </div>
                </Card>
                <ScrollTop />
                <WFTrans ref={e => this.wfTransDlg = e}></WFTrans>
                <Attachments ref={e => this.dlgAttachments = e}></Attachments>
            </div >
        );
    }

    handleChange = (event) => {
        if (event.target.files.length > 0) {
            let _uploadedFile = URL.createObjectURL(event.target.files[0])
            let _isUpdatedFile = this.state.dataObject.file_id > 0 ? true : false
            if (event.target.files[0].size > 4 * 1024 * 1024) {
                Util.showErrorMsg(this.messages, $.strings.fileSizeError);
                document.getElementById('file-upload').value = ''
                return
            }
            this.setState({
                dataObject: {
                    ...this.state.dataObject, uploadedFile: _uploadedFile, uploadedFileBytes: null,
                    uploadedFile2: event.target.files[0], isUpdatedFile: _isUpdatedFile
                }
            }, () => this.setSubscriberImgSrc())
        }
    }

    handleChangePrime = (event) => {
        if (event.files.length > 0) {
            let _uploadedFile = event.files[0];
            let _isUpdatedFile = this.state.dataObject.file_id > 0 ? true : false
            if (event.files[0].size > 5 * 1000 * 1000) {
                Util.showErrorMsg(this.messages, $.strings.fileSizeError);
                return
            }
            this.setState({
                dataObject: {
                    ...this.state.dataObject, uploadedFile: _uploadedFile, uploadedFileBytes: null,
                    uploadedFile2: event.files[0], isUpdatedFile: _isUpdatedFile
                }
            }, () => this.setSubscriberImgSrc())
        }
    }

    setSubscriberImgSrc = () => {
        alert($.strings.fileUploaded)
    }

    getEmployeeInfo = async (empCode) => {
        let dataTemp = []
        let obj = {
            empCode: empCode,
            isHr: Util.checkISHR(),
            userId: localStorage.getItem('useridHR')
        }
        let res = await http.getJsonAxios(http.actions.Employee.urlGetEmployeeInfo, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.EmployeeInfoObj;
        }
        return dataTemp
    }

    showWorkLeave = async (id) => {
        let dataTemp = []
        let obj = {
            id: id
        }
        let res = await http.getJsonAxios(http.actions.HolidaysReq.urlGetHolidayReq, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data;
        }
        return dataTemp
    }

    loadData = (data) => {
        let period = this.state.periodList.filter(element => element.id + "" === data.period + "")
        if (period && period.length > 0)
            period = period[0]

        let fromTime = new Date(data.FromTime)
        let toTime = new Date(data.toTime)

        this.setState({
            mode: 'view',
            isDesktop: this.updatePredicate(),
            dataObject: {
                ...this.state.dataObject,
                id: data.serial,
                empCode: data.empNo,
                empName: data.empName,
                requestDate: new Date(data.insDate),
                period: period,
                fromDate: new Date(data.fromDate),
                toDate: new Date(data.toDate),
                daysCount: data.dayCaption,
                fromTime: fromTime.getFullYear() + "" === "1" ? '' : fromTime,
                toTime: toTime.getFullYear() + "" === "1" ? '' : toTime,
                duration: '00:00',
                notes: data.notes,

                uploadedFile: null,
                uploadedFile2: null,
                uploadedFileBytes: null,
                file_id: data.AttachValue,
            }
            , loading: false
        })
    }

    wfTransDetails = async () => {
        let id = Util.encryptStringToHexa(this.state.dataObject.id);
        await this.wfTransDlg.show(1, id)
    }

    onShowAttachment = async () => {
        await this.dlgAttachments.show(1, this.state.dataObject.id)
    }

    onSave = async () => {
        if (!this.validateField()) {
            this.setState({ loading: false })
            return false;
        }
        this.messages.clear();
        this.setState({ loading: true })
        let files = [] // ملفات المرفقات
        let file = this.state.dataObject.uploadedFile2

        let obj = {
            serial: !this.state.dataObject.id ? 0 : this.state.dataObject.id,
            empcode: this.state.dataObject.empCode,
            FromTime: this.state.dataObject.fromTime,
            toTime: this.state.dataObject.toTime,
            notes: this.state.dataObject.notes,
            period: this.state.dataObject.period ? this.state.dataObject.period.id : 0,
            transType: 2,
            transTypeText: $.strings.workLeave.title,
            alternativeEmp: '',
            alternativeEmp2: '',
            address: '',
            phone: '',
            empNo: this.state.dataObject.empCode,
            fromDate: this.state.dataObject.fromDate,
            toDate: this.state.dataObject.toDate,
            userCode: localStorage.getItem("useridHR"),
            checkVacationRequestPeriod: false
        }
        console.log(obj)
        let res = await http.postMultipartAxios(http.actions.HolidaysReq.urlPostSaveWorkLeave, obj, file, files, 0);
        if (res.status === 200) {
            if (res.data.success) {
                if (res.data.errorText)
                    Util.showSuccessMsg(this.messages, res.data.errorText);
                else
                    Util.showSuccessMsg(this.messages);
                this.resetFields()
                this.hash = this.hashState()
                this.setState({ loading: false })
                return true
            }
        }
        if (res.data.errorText !== "") {
            Util.showErrorMsg(this.messages, res.data.errorText);
            this.setState({ loading: false })
            return false
        }
        else {
            Util.showErrorMsg(this.messages);
            this.setState({ loading: false })
            return false
        }
    }

    resetFields = () => {
        this.nowDate = new Date()
        this.toDate = new Date();
        this.toDate.setHours(this.nowDate.getHours()+1,this.nowDate.getMinutes(),0);
        this.setState({
            dataObject: {
                ...this.state.dataObject,
                id: 0,
                empCode: localStorage.getItem("useridHR") || '',
                empName: Util.getEmployeeInfo() || '',
                requestDate: new Date(),
                period: { id: 0, name: $.strings.workLeave.lessThanDay },

                fromDate: new Date(),
                toDate: new Date(),
                daysCount: 0,
                fromTime: this.nowDate,
                toTime: this.toDate,
                duration: '01:00',
                notes: ''
            },
            formErrors: { empCode: '', empName: '', period: '', fromDate: '', toDate: '', fromTime: '', toTime: '', notes: '' },
        }
            //, () => { document.getElementById('file-upload').value = ''; }
        )
    }
}